import { useState } from 'react'

import { useToast } from '@wartek-id/toast'

import { useAPIUploadMediaManager } from 'api/kinerja/useAPIKinerja'

import type { CustomError } from 'types/custom-error'
import type {
  IMediaManagerResponse,
  TMediaManagerUploadType,
} from 'types/kinerja-pelaksanaan'

type UseMediaManagerProps = {
  uploadType: TMediaManagerUploadType
  onSuccess?: (file: IMediaManagerResponse) => void
  onError?: (error: CustomError) => void
}

export default function useMediaManager({
  uploadType,
  onError,
  onSuccess,
}: UseMediaManagerProps) {
  const useMutation = useAPIUploadMediaManager()
  const [isLoading, setIsLoading] = useState(false)
  const [fileUploaded, setFileUploaded] =
    useState<IMediaManagerResponse | null>(null)
  const toast = useToast()

  const handleUpload = async (file: File) => {
    setIsLoading(true)
    const payload: FormData = new FormData()
    payload.append('uploadType', uploadType)
    payload.append('file', file)
    useMutation.mutate(payload, {
      onSuccess: (data) => {
        const file = data.data[0]
        setFileUploaded(file)
        onSuccess?.(file)
      },
      onSettled: () => setIsLoading(false),
      onError: (error: CustomError) => {
        setIsLoading(false)
        if (typeof onError === 'function') {
          onError(error)
        } else {
          toast({ message: error.originalError.response.data.message })
        }
      },
    })
  }
  return { handleUpload, isLoading, fileUploaded }
}
